export default function Hero() {

  const handleScrollToContact = () => {
    const element = document.querySelector('#contact')
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{ backgroundColor: 'var(--color-cream-light)' }}
    >
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover"
      >
        <source src="/hero-video-c.mp4" type="video/mp4" />
      </video>

      {/* Overlay */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(180deg, rgba(62, 60, 42, 0.4) 0%, rgba(62, 60, 42, 0.6) 100%)'
        }}
      />

      {/* Content */}
      <div className="relative z-10 container-custom text-center px-4">
        <div className="max-w-3xl mx-auto">
          {/* Tagline */}
          <p
            className="text-sm md:text-base font-medium tracking-[0.2em] uppercase mb-6 animate-fade-in text-white/80"
          >
            Yoga & Wellness
          </p>

          {/* Main Heading */}
          <h1
            className="font-heading text-5xl md:text-7xl lg:text-8xl font-medium mb-8 animate-slide-up text-white"
            style={{ animationDelay: '0.1s' }}
          >
            OM with Madi
          </h1>

          {/* Subtitle */}
          <p
            className="text-lg md:text-xl font-light max-w-xl mx-auto mb-12 leading-relaxed animate-slide-up text-white/90"
            style={{ animationDelay: '0.2s' }}
          >
            Find your flow. Connect with your breath.
            Discover peace within movement.
          </p>

          {/* CTA Button */}
          <div
            className="animate-slide-up"
            style={{ animationDelay: '0.3s' }}
          >
            <button
              onClick={handleScrollToContact}
              className="btn-primary"
            >
              Begin Your Journey
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <div
          className="w-6 h-10 rounded-full border-2 border-white/50 flex items-start justify-center p-2"
        >
          <div
            className="w-1 h-2 rounded-full bg-white/50"
          />
        </div>
      </div>
    </section>
  )
}
